import React from 'react';
import PropTypes from 'prop-types';
// Components
import Text from '../../Global/Text';

export const InfoSection = (props) => {
  const {
    title,
    infoBoxList = []
  } = props;
  return (
    <div class="receipt__info">
      <anchor-help-box class="receipt__info-box--conatiner">
        <h2 className="receipt__info-box--heading heading">
          <Text value={title} />
        </h2>
        <div className="receipt__info-box--list">
          {infoBoxList.map((item, index) => (
            <div key={index} className="receipt__info-box--list-item">
              <anchor-icon name={item.icon} size={'medium'} />
              <span className="receipt__info-box--list-text">
                <Text value={item.text} />
              </span>
            </div>
          ))}
        </div>
      </anchor-help-box>
    </div>
  )
}

InfoSection.propTypes = {
  infoBoxList: PropTypes.array.isRequired,
  title: PropTypes.string
};